<template>
    <div class="modal fade" :id="id" tabindex="-1">
      <div class="modal-dialog">
        <form @submit.prevent="submitForm" class="form">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">{{ edit ? $t('financial.accounts.modal_box.edit_title') : $t('financial.accounts.modal_box.creation_title') }}</h5>
              <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" @click="closeModal">
                  <span class="svg-icon svg-icon-1">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                            fill="currentColor" />
                      <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                            fill="currentColor" />
                    </svg>
                  </span>
              </div>
            </div>
            <div class="modal-body">
              <RequiredText />
              <Input
                container-class="form-group mb-5"
                :name="`name`+ id"
                type="text"
                :label="$t('financial.accounts.modal_box.name')"
                labelClass="form-label fs-6 text-black"
                :inputClass="'form-control form-control-lg form-control-solid'"
                size="lg"
                v-model="formData.name"
              />
              <div class="form-group mb-5" v-if="!edit">
                  <label class="form-label fs-6 text-black">{{ $t('financial.accounts.modal_box.amount') }}</label>

                  <VueNumberFormat v-model:value="formData.initial_amount" class="form-control form-control-solid" :options="{ precision: 0, prefix: '', acceptNegative: false, isInteger: false  }"
                  ></VueNumberFormat>
              </div>
              <Select2
                v-if="!edit"
                :parent-id="'#'+id"
                :name="`currency`+ id"
                :multiple="false"
                labelClass="form-label fs-6 text-black"
                :label="$t('financial.accounts.modal_account.currency')"
                selectClass="form-select form-select-solid kt_select2"
                :isRequired="true"
                :placeholderText="$t('financial.accounts.modal_account.currency')"
                v-model="formData.currency_id"
              >
                <option :value="currency.id" v-for="currency in currencies" :key="currency.id">{{ currency.name + ' (' +  currency.iso + ')'}}</option>
              </Select2>
            </div>
            <div class="modal-footer">
              <Button type="cancel" id="cancel_btn" btn-class="btn-sm me-3" size="7px 30px" btn-text="button.cancel" @click="closeModal"></Button>
              <Button btn-class="btn-sm me-3" type="submit" id="submit_btn" btn-text="button.save" size="7px 30px" :is-loading="isLoading"></Button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </template>
  
  <script setup>
    import {ref, defineEmits, defineProps, computed, onMounted} from "vue";
    import Input from "@/components/Input.vue";
    import {useStore} from "vuex";
    import Button from "@/components/Button.vue"
    import InputDate from "@/components/InputDate2.vue";
    import CustomSelect2 from "@/components/CustomSelect2.vue";
    import InputAmount from "@/components/InputAmount.vue";
    import RequiredText from "@/components/RequiredText.vue";
    import Select2 from "@/components/Select2.vue";
    import VueNumberFormat from 'vue-number-format'

    const store = useStore()

    const currencies = computed(() => store.getters['currencies/getCurrencies'])
    
    const emits = defineEmits(['load'])
    const props = defineProps({
        id: {
          type: String,
          required: true
        },
        office: {
          type: String,
          required: true
        },
        form: {
          type: Object,
          default: {
            id: '',
            name: '',
            initial_amount: 0,
            currency_id: '',
            office_id: ''
          }
        },
        edit: {
          type: Boolean,
          default: false
        }
    })
    const isLoading = ref(false)
    const formData = ref(props.form)
  
    function closeModal(){
        $('#'+props.id).modal('toggle')
    }

    function submitForm(){
      formData.value.office_id = props.office
      isLoading.value = true
        if(!props.edit){
          store.dispatch('accounts/createBox', formData.value)
            .then((response) => {
                isLoading.value = false
                emits('load')
                emits('box', response.data.box?.id)
                closeModal()
                formData.value.name= '',
                formData.value.initial_amount= 0,
                formData.value.currency_id= ''

                window.toastr['success'](i18n.global.t('notification.box_created_successfully'))
            })
            .catch(err => {
                isLoading.value = false
            })
        }else{
          store.dispatch('accounts/updateBox', formData.value)
            .then((response) => {
                isLoading.value = false
                emits('load')
                closeModal()
                formData.value.name= ''

                window.toastr['success'](i18n.global.t('notification.box_updated_successfully'))
            })
            .catch(err => {
                isLoading.value = false
            })
        }
    }
</script>
    
<style scoped>
  .icon-wrapper {
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .icon-wrapper i {
    position: relative;
    font-size: 1.5em;
  }

  .icon-wrapper .icon-text {
    position: absolute;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 9px;
    color: white;
    margin-top: 8px;
  }
</style>